import { MessageSquare } from 'lucide-react';
import { useNavigate } from '@tanstack/react-router';

interface MessageIconButtonProps {
  count: number;
  to: string;
  /** Extra classes — e.g. `lg:hidden` so it only shows on mobile where the
   *  sidebar (with its own Messages badge) is collapsed into the drawer. */
  className?: string;
}

export function MessageIconButton({ count, to, className = '' }: MessageIconButtonProps) {
  const navigate = useNavigate();

  return (
    <button
      type="button"
      onClick={() => navigate({ to })}
      aria-label={count > 0 ? `${count} unread messages` : 'Messages'}
      className={`relative flex h-9 w-9 items-center justify-center rounded-lg bg-muted/60 text-muted-foreground hover:text-foreground ${className}`}
    >
      <MessageSquare className="h-4 w-4" />
      {count > 0 && (
        <span className="absolute -right-1 -top-1 flex h-4 min-w-[16px] items-center justify-center rounded-full bg-[#ff5a1f] px-1 text-[10px] font-semibold leading-none text-white">
          {count > 9 ? '9+' : count}
        </span>
      )}
    </button>
  );
}
